import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { enrollModal, selectOptionData, setSubscribeModal, showModal, subscriptionPageNode } from "../../redux/actions";
import { PATHS } from "../../utils";
import { ParentSignIn } from "../base";
import ChildEnrollmentPopUp from "../base/ChildEnrollmentPopUp";
import InviteFriend from "../base/InviteFriend";
import InviteParent from "../base/InviteParent";
import EnrollmenHalfScreen from "../coursecatlog/EnrollmenHalfScreen";
import Feedback from "../feedback";
import MyLockerScreen from "../home/MyLockerScreen";
import ShowNuggetPopup from "../home/ShowNuggetPopup";
import MyLearnerPlanRedirectPopup from "../learnerplan/MyLearnerPlanRedirectPopup";
import Subscription from "../subscription/Subscription";
import PlanGoals from "../myplans/PlanGoals";
import CalenderView from "../learnerplan/CalenderView";
import CourseDetailsPage from "../dimensions/CourseDetailsPage";
import GeneralSetting from "../setting/GeneralSetting";
import CouponPopUp from "../base/CouponPopUp";
import DisCountOfferPopup from "../base/DisCountOfferPopup";
import DimensionHint from "../widget/DimensionHint";
import { TIPS } from "../../utils/DataObjects";
import DashBoardEmptyPopUp from "../homeview/DashBoardEmptyPopUp";
import DowngradeModal from "../subscription/DowngradeModal";
import SelectChildPopup from "../subscription/SelectChildPopup";
import QuizInformation from "../base/QuizInformation";
import AddReward from "../setting/AddReward";
import TeacherProfile from "../profile/teacher/TeacherProfile";
import RewardUnlockPopup from "../widget/RewardUnlockPopup";
import { getRewardData } from "../../redux/actions/APIs";
import RewardPopUp from "../base/RewardPopUp";
import LockPopup from "../controls/LockPopup";

const ImportFile = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {
        alluserdetails,
        loggedInUser,
        defaultChildData,
        selectOptData,
        modalData,
        enrollObj,
        parentLogin,
        courseModal,
        downgradeObj,
        selectChildObj,
        providerModal,
        courseDetails,
        lockPopupData,
    } = useSelector((state) => state.collections);

    const closeNugget = () => {
        dispatch(selectOptionData({ ...selectOptData, type: "" }));
    };

    const closeSubcription = () => {
        dispatch(showModal());
        dispatch(subscriptionPageNode());
        localStorage.removeItem("subscriptionData");
    };

    const closeModal = () => {
        dispatch(showModal());
    }

    const closeReward = ()=>{
		 dispatch(getRewardData());
         closeModal();
		 
	}


    const closeEnrollModal = () => {
        dispatch(enrollModal())
    }

    const showLockerScreen = (value, childData) => {
        dispatch(showModal({ type: value, childData: childData }));
    }

    //  console.log("handleEnroll : ", modalData);
    const handleRedirectPopUp = () => {
        dispatch(showModal());
        history.push({
            pathname: PATHS.COURSE_CATLOG_STR + defaultChildData?.id,
            state:{type: "Developmental"}
            //  state:{type: "Challenges"}
        })
    }

    

    const [showTips, setShowTips] = useState();
    const [tipsData, setTipsData] = useState();
    const [step, setStep] = useState(0);

    const next = (hintIndex, classname) => {
        setStep(1);
        if (classname == "WelcomePOpScreen") {
            setTipsData(TIPS[1]);
            document.body.classList.remove("first-place");
            document.body.classList.add("second-place");
            document.body.classList.remove("third-place");
            document.body.classList.remove("fourth-place");
            document.body.classList.remove("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.remove("seventh-place");
            document.body.classList.remove("eighth-place");
            document.body.classList.remove("ninth-place");
            document.body.classList.remove("tenth-place");
        }
        if (classname == "first-place") {
            setTipsData(TIPS[2]);
            document.body.classList.remove("first-place");
            document.body.classList.remove("second-place");
            document.body.classList.remove("third-place");
            document.body.classList.remove("fourth-place");
            document.body.classList.remove("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.remove("seventh-place");
            document.body.classList.add("eighth-place");
            document.body.classList.remove("ninth-place");
            document.body.classList.remove("tenth-place");
        }
        if (classname == "third-place") {
            setTipsData(TIPS[3]);
            document.body.classList.remove("first-place");
            document.body.classList.remove("second-place");
            document.body.classList.add("third-place");
            document.body.classList.remove("fourth-place");
            document.body.classList.remove("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.remove("seventh-place");
            document.body.classList.remove("eighth-place");
            document.body.classList.remove("ninth-place");
            document.body.classList.remove("tenth-place");
        }
        if (classname == "ninth-place") {
            setTipsData(TIPS[6]);
            document.body.classList.remove("first-place");
            document.body.classList.remove("second-place");
            document.body.classList.remove("third-place");
            document.body.classList.remove("fourth-place");
            document.body.classList.add("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.remove("seventh-place");
            document.body.classList.remove("eighth-place");
            document.body.classList.remove("ninth-place");
            document.body.classList.remove("tenth-place");
        }
        if (classname == "sixth-place") {
            setShowTips(false);
            document.body.classList.remove("first-place");
            document.body.classList.remove("second-place");
            document.body.classList.remove("third-place");
            document.body.classList.remove("fourth-place");
            document.body.classList.remove("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.remove("seventh-place");
            document.body.classList.remove("eighth-place");
            document.body.classList.remove("ninth-place");
            document.body.classList.remove("tenth-place");
            localStorage.setItem("skip", true);
        }
        if (classname == "seventh-place") {
            setTipsData(TIPS[2]);
            // setShowTips(false);
            document.body.classList.remove("first-place");
            document.body.classList.remove("second-place");
            document.body.classList.remove("third-place");
            document.body.classList.remove("fourth-place");
            document.body.classList.remove("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.add("seventh-place");
            document.body.classList.remove("eighth-place");
            document.body.classList.remove("ninth-place");
            document.body.classList.remove("tenth-place");
        }
        if (classname == "eighth-place") {
            setTipsData(TIPS[1]);
            // setShowTips(false);
            document.body.classList.remove("first-place");
            document.body.classList.remove("second-place");
            document.body.classList.remove("third-place");
            document.body.classList.add("fourth-place");
            document.body.classList.remove("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.remove("seventh-place");
            document.body.classList.add("eighth-place");
            document.body.classList.remove("ninth-place");
            document.body.classList.remove("tenth-place");
        }
        if (classname == "fivth-place") {
            setTipsData(TIPS[7]);
            // setShowTips(false);
            document.body.classList.remove("first-place");
            document.body.classList.remove("second-place");
            document.body.classList.remove("third-place");
            document.body.classList.remove("fourth-place");
            document.body.classList.remove("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.remove("seventh-place");
            document.body.classList.remove("eighth-place");
            document.body.classList.add("ninth-place");
            document.body.classList.remove("tenth-place");
        }
        if (classname == "fourth-place") {
            setTipsData(TIPS[4]);
            // setShowTips(false);
            document.body.classList.remove("first-place");
            document.body.classList.remove("second-place");
            document.body.classList.remove("third-place");
            document.body.classList.add("fourth-place");
            document.body.classList.remove("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.remove("seventh-place");
            document.body.classList.remove("eighth-place");
            document.body.classList.add("ninth-place");
            document.body.classList.remove("tenth-place");
        }
        if (classname == "tenth-place") {
            setTipsData(TIPS[8]);
            //	setShowTips(false);
            document.body.classList.remove("first-place");
            document.body.classList.remove("second-place");
            document.body.classList.remove("third-place");
            document.body.classList.remove("fourth-place");
            document.body.classList.remove("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.remove("seventh-place");
            document.body.classList.remove("eighth-place");
            document.body.classList.remove("ninth-place");
            document.body.classList.remove("tenth-place");
            localStorage.setItem("skip", true);
        }
    };
    const skip = () => {
        window.scrollTo(0, 0);
        setShowTips(false);
        document.body.classList.remove("first-place");
        document.body.classList.remove("second-place");
        document.body.classList.remove("third-place");
        document.body.classList.remove("fourth-place");
        document.body.classList.remove("fivth-place");
        document.body.classList.remove("sixth-place");
        document.body.classList.remove("seventh-place");
        document.body.classList.remove("eighth-place");
        document.body.classList.remove("ninth-place");
        document.body.classList.remove("tenth-place");
        localStorage.setItem("skip", true);
    };
    useEffect(() => {
        if (
            alluserdetails?.records[0]?.uistate &&
            loggedInUser?.role?.name == "PARENT"
        ) {
            setShowTips(false);
            document.body.classList.remove("second-place");
            document.body.classList.remove("third-place");
            document.body.classList.remove("fourth-place");
            document.body.classList.remove("fivth-place");
            document.body.classList.remove("sixth-place");
            document.body.classList.remove("seventh-place");
            document.body.classList.remove("eighth-place");
        } else {
            if (localStorage.getItem("skip")) {
                document.body.classList.remove("second-place");
                document.body.classList.remove("third-place");
                document.body.classList.remove("fourth-place");
                document.body.classList.remove("fivth-place");
                document.body.classList.remove("sixth-place");
                document.body.classList.remove("seventh-place");
                document.body.classList.remove("eighth-place");
                setShowTips(false);
            } else {
                if (step === 0) {
                    setTipsData(TIPS[0]);
                    document.body.classList.add("WelcomePOpScreen");
                    setShowTips(true);
                }
            }
        }
    }, [alluserdetails, alluserdetails?.records[0]?.uistate]);

    useEffect(() => {
        if (modalData?.type === "DimensionHintPopup") {
            setTipsData(TIPS[0]);
            document.body.classList.add("WelcomePOpScreen");
            setShowTips(true);
        }
    }, [modalData?.type])

    return (
        <React.Fragment>
            {selectOptData?.type === "ShowNuggetPopup" && selectOptData?.optNuggetData[0]?.help && (
                <ShowNuggetPopup closeNugget={closeNugget} modalData={selectOptData} />
            )}
            {modalData?.type === "Subscription" && (
                <Subscription close={closeSubcription} />
            )}
            {modalData?.type === "ChildEnrollmentPopUp" && (
                <ChildEnrollmentPopUp closeModal={closeModal} />
            )}
            {enrollObj && (
                <EnrollmenHalfScreen closeModal={closeEnrollModal} courseData={enrollObj} />
            )}
            {parentLogin && parentLogin && (
                <ParentSignIn />
            )}
            {modalData?.type === "Subscription" && (
                <Subscription close={closeModal} />
            )}
            {modalData?.type === "InviteParent" && (
                <InviteParent />
            )}
            {modalData?.type === "MyLockerScreen" && (
                <MyLockerScreen showLockerScreen={showLockerScreen} childData={modalData?.childData} activeTab={modalData?.activeTab} />
            )}
            {modalData?.type === "Invite" && (
                <InviteFriend />
            )}
            {modalData?.type === "feedback" && (
                <Feedback closeModal={closeModal} />
            )}
            {modalData?.type === "MyLearnerPlanRedirectPopup" && (
                <MyLearnerPlanRedirectPopup handleRedirectPopUp={handleRedirectPopUp} />
            )}
            {modalData?.type === "PlanGoals" && (
                <PlanGoals closeModal={closeModal} myplanData={modalData?.myplanData} dashBoardPlanData={modalData?.dashBoardPlanData} childData={modalData?.childData} />
            )}
            {modalData?.type === "CalenderVaiew" && (
                <CalenderView closePopup={closeModal} />
            )}
            {courseModal  && (
                <CourseDetailsPage data={courseModal}
                // handlePopUp={handlePopUp}
                />
            )}
             {providerModal && (
				<TeacherProfile data={providerModal} 
                 // handlePopUp={handlePopUp} 
                />
			)}
            {modalData?.type === "setting" && (
                <GeneralSetting
                    closeSetting={closeModal}
                />
            )}
           
            {modalData?.type === "showCouponPopUp" && (
                <CouponPopUp closePopup={closeModal} />
            )}

            {(modalData?.type === "DisCountOfferPopup" && loggedInUser?.role?.name == "PARENT") && (
                <DisCountOfferPopup closePopup={closeModal} />
            )}

            {modalData?.type === "DimensionHintPopup" && (
                <DimensionHint
                    skip={skip} data={tipsData} next={next}
                />
            )}

            {modalData?.type === "DashBoardEmptyPopUp" && (
                <DashBoardEmptyPopUp closePopup={closeModal} />
            )}                   
            {downgradeObj && (
                <DowngradeModal data={downgradeObj} />   
            )}
            {selectChildObj && (
                <SelectChildPopup data={selectChildObj} />
            )}
            {modalData?.type === "QuizInformation" && (
				<QuizInformation closePopup={closeModal} quizType={modalData?.quizType} />
			)}
            {modalData?.type === "AddReward" && (
					<AddReward
						object={modalData?.data}
						closeReward={closeReward}
					/>
				)
			}
            {modalData?.type === "RewardUnlockPopup" && (
                <RewardUnlockPopup
                    handleShowRewardUnlockPopup={closeModal}
                    rewardData={modalData?.rewardData}
                />
            )}
            {modalData?.type === "RewardPopUp" && (
				<RewardPopUp
					closeReward={closeReward}
					rewardDataWithoutAPI={modalData?.courseObj}
				/>
			)}
            {
                // defaultChildData?.isSubscriber &&
				 lockPopupData?.isLocked && (
					<LockPopup type={lockPopupData?.courseObj} />
				)
			}
        </React.Fragment>
    );
}
export default ImportFile;